module.exports = __webpack_public_path__ + "img/home-agenda-Entreprises-et-sante-le-travail-guerit.6e426a23.jpg";